export const IMPORT_TYPE_TAB: string = 'tab';

export const IMPORT_TYPE_LIST_DEAL: ImportTypeItem[] = [
  {
    id: 1,
    name: IMPORT_TYPE_TAB,
    label: 'Current tab',
  },
];
